import { setSelectedAction, createFilterActionType } from '@modules/Filters';
import { KEY, SET_SORT_METRIC } from './constants';

export const setSelected = (values) => setSelectedAction(KEY, values);

export const setSortMetric = (values) => ({
  type: createFilterActionType(KEY, SET_SORT_METRIC),
  values,
});
